import React from "react";

export const SmallCircleGreenTick = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
  >
    <rect
      x="0.129272"
      y="0.5"
      width="12"
      height="12"
      rx="6"
      fill="currentColor"
    />
    <path
      d="M4.25427 6.85402L5.45427 7.96307L8.25427 5.375"
      stroke="white"
      strokeWidth="1.26"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
